import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {PlayerTable} from './PlayerTable';
import Chart from './Chart';
import metadata from '../data/metadata.json';
import {format} from 'date-fns';

const RatingPage = ({playerData, children}) => {
  const transformedDate = format(new Date(metadata.lastUpdated), 'do MMMM yyyy');
  return (
    <>
      <Row>
        <Col>
          <h2>{children}</h2>
          <PlayerTable data={playerData} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Chart players={playerData} />
        </Col>
      </Row>
      <Row>
        <Col>
          <strong style={{color: 'red'}}>
            N.B: The data collection is done by a <em>manually ran scrapper (since the PDGA does not have an API)</em>,
            so the data <em>may be</em> a month behind.
          </strong>
          <br />
          <i>
            Last updated on the <time dateTime={metadata.lastUpdated}>{transformedDate}</time>
          </i>
        </Col>
      </Row>
    </>
  );
};

export default RatingPage;
